import { gql } from "@apollo/client"

export const GET_STORE_DETAIL = gql`
  query Store($id: Int!) {
    Store(id: $id) {
      id
      name
      description
      addressId
      logo
      urlLogo
      cover
      urlCover
      phone
      email
      active
      siteUrl
      facebookUrl
      inChargePerson
      client
      clasificationId
      instagramUrl
      youtubeUrl
      twitterUrl
      levelId
      urlView
      urlTournaments
      urlPastTournaments
      levelId
      personId
      Level {
        id
        name
        description
        icon
      }
      Person {
        id
        avatar
        fullName
        urlAvatar
        active
        code
        name
        email
        urlEdit
      }
      StoreTournamentDays {
        TournamentDay {
          id
          name
        }
      }
      StoreTournamentTypes {
        id
        storeId
        typeId
        quantity
      }
      StoreGames {
        id
        gameId
        storeId
        Game {
          name
        }
      }
      Address {
        id
        name
        address
        countryId
        regionId
        locationId
        Location {
          name
        }
      }
    }
  }
`
